import marketingFonts from '@shared/utils/fonts/marketingFonts';
import { buttonColors } from './ButtonConfigs';
import type { Flavor, Intent, buttonType } from './ButtonConfigs';
import { Theme, css, styled } from '@withjoy/joykit';

// Disabled in a special case with only 1 type for all states (active, hover, default)
const calcColorCSSForButton = (theme: Theme, intent: Intent, flavor: Flavor, disabled?: boolean, type?: buttonType) => {
  const { hover, active, default: cDefault } = buttonColors({ theme })[intent][flavor];
  if (intent === 'secondary') {
    return disabled
      ? css`
          background-color: 'transparent';
          border: solid 1px;
          border-color: ${theme.colors.mono6};
          color: ${theme.colors.mono6};
        `
      : css`
          background-color: ${cDefault.backgroundColor};
          border: solid 1px;
          border-color: ${cDefault.borderColor};
          color: ${cDefault.color};
          &:hover:enabled {
            background-color: ${hover.backgroundColor};
            border-color: ${hover.borderColor};
          }
          &:hover:enabled:active:focus,
          &:active:enabled {
            background-color: ${active.backgroundColor};
            border-color: ${active.borderColor};
          }
        `;
  }
  return disabled
    ? css`
        background-color: ${theme.colors.mono3};
        color: ${theme.colors.mono6};
      `
    : css`
        background-color: ${cDefault.backgroundColor};
        color: ${cDefault.color};
        &:hover:enabled {
          background-color: ${hover.backgroundColor};
          color: ${hover.color};
        }
        &:hover:enabled:active:focus,
        &:active:enabled {
          background-color: ${active.backgroundColor};
          color: ${active.color};
        }
      `;
};

/*
 // This button can only be used with the old joykit-provider
 * This button *should be able to be used* with the JoyKitProviderV2
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const StyledButton = styled.button.withConfig({ componentId: 'components-Button-StyledButton' } as any)<{
  theme: Theme;
  intent?: Intent;
  color?: Flavor;
  $small?: boolean;
  disabled?: boolean;
  collapse?: boolean;
  type?: buttonType;
  fill?: boolean;
}>`
  ${({ intent }) => (intent === 'secondary' ? marketingFonts.FeatureCopy17 : marketingFonts.FeatureHead15)}
  ${({ theme, intent, color, disabled, type }) => calcColorCSSForButton(theme, intent || 'primary', color || 'brand', disabled, type || 'submit')};
  min-height: ${({ $small, intent }) => ($small ? '40px' : intent === 'primary' ? '48px' : '50px')};
  min-width: ${props => (props.collapse ? 0 : 'inherit')};
  padding: ${props => (props.$small ? '0 1rem' : '0 1.5rem')};
  width: ${props => (props.fill ? '100%' : 'inherit')};
  border-radius: 4px;
  transition: all 0.16s;
  &:focus:not(:focus-visible) {
    outline: none;
  }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ButtonContainer = styled.div.withConfig({ componentId: 'components-Button-ButtonContainer' } as any)`
  & > button {
    margin-right: 16px;
    margin-bottom: 16px;
    &:last-child {
      margin-right: 0;
      margin-bottom: 0;
    }
  }
`;
